<template>
  <div class="charging-record-item" @click="$emit('click', record)">
    <div class="record-time">
      <span v-if="record.startTime">{{ record.startTime | dateFormat('MM-dd hh:mm') }}</span>
      ~
      <span v-if="record.endTime">{{ record.endTime | dateFormat('hh:mm') }}</span>
    </div>
    <div class="record-info">
      <span class="record-soc-wrapper">
        <span v-if="record.startSoc !== undefined && record.startSoc !== null" class="record-soc">
          电量：{{ record.startSoc }}% ~ {{ record.endSoc }}%
          <span v-if="record.avgCur" style="margin-left: 10px;">
            {{ record.avgCur | numFormat(0) }}A {{ record.superCharge ? '快充' : '慢充' }}
          </span>
        </span>
      </span>
      <span class="record-duration-wrapper">
        <span v-if="record.totalChargingMinutes !== undefined && record.totalChargingMinutes !== null"
          class="record-duration">
          时长：{{ record.totalChargingMinutes | minuteToTimeFilter }}
        </span>
        <span v-if="record.chargingCapacity !== undefined && record.chargingCapacity !== null" class="record-soc">
          充电：{{ record.chargingCapacity }} %
        </span>
      </span>
      <span class="record-position-wrapper" v-if="chargePosition">
        <span class="record-position">
          位置：{{ chargePosition }}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChargingRecordItem",
  props: {
    record: {
      type: Object,
      required: true
    }
  },

  filters: {
    minuteToTimeFilter(value) {
      // 将分钟转化为小时和分钟
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      if (hours > 0) {
        return `${hours}时${minutes}分`;
      } else {
        return `${minutes}分钟`;
      }
    }
  },
  computed: {
    chargePosition() {
      // 优先显示起始充电位置，如果没有则显示结束充电位置
      if (this.record.startChargePosition && this.record.startChargePosition.name) {
        return this.record.startChargePosition.name;
      }
      if (this.record.endChargePosition && this.record.endChargePosition.name) {
        return this.record.endChargePosition.name;
      }
      return null;
    }
  }
};
</script>

<style lang="less" scoped>
.charging-record-item {
  padding: 12px 0;
  border-bottom: 1px solid #F5F7FA;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f5f7fa;
  }

  .record-time {
    font-size: 13px;
    color: #606266;
    margin-bottom: 6px;
    font-weight: 500;
  }

  .record-info {
    .record-soc-wrapper {
      display: flex;
      gap: 8px;

      >.record-soc {
        flex: 1;
      }

      margin-bottom: 4px;
    }

    .record-duration-wrapper {
      display: flex;
      gap: 8px;

      >.record-duration,
      >.record-soc {
        flex: 1;
      }
    }

    .record-position-wrapper {
      display: flex;
      margin-top: 4px;
    }

    .record-soc,
    .record-duration,
    .record-position {
      font-size: 12px;
      color: #909399;
    }
  }
}
</style>
